import { PutOcrAccountsApi } from "@/features/accounts/ocr/services/put-accounts-api";
import { PutOcrAccountsRequestModel } from "@/features/accounts/ocr/services/put-accounts-model";

/// OCR口座情報更新処理
export class PutOcrAccountsService {
  private putOcrAccountsApi = new PutOcrAccountsApi();

  /**
   * OCR口座情報更新API実行
   */
  public async putOcrAccounts(param: PutOcrAccountsRequestModel) {
    return await this.putOcrAccountsApi.putOcrAccounts(param);
  }
}
